import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import template from './index.jade';
import css from './index.styl?inline';

export class DropMenuPane extends Component {
  static get attrsSchema() {
    return {
      header: `string`,
      'show-back-button': `boolean`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,

      helpers: {
        clickedBackButton: () => this.dispatchEvent(new CustomEvent(`back-click`)),
      },
    };
  }
}

export const DropMenuPaneEl = defineAndMakeJsxFactory(`mp-drop-menu-pane`, DropMenuPane);
